<template>

  <div>
    <!-- select asset -->
    <v-btn depressed v-if="alarm.assetId" @click="$emit('map', alarm.assetId)" :title="$t('alarms.show.map')">
      <font-awesome-icon icon="map-marked-alt" size="lg" fixed-width></font-awesome-icon>
    </v-btn>

    <!-- link to logs -->
    <v-btn depressed
           v-if="alarm.asset.shvPath"
           @click="$router.push({ name: 'logs', query: { assets: alarm.assetId, from: alarm.detectedAt, to: null }, params: { associatedAssets: true }})"
           :title="$t('alarms.show.logs')"
    >
      <font-awesome-icon icon="chart-line" size="lg" fixed-width></font-awesome-icon>
    </v-btn>

    <!-- link to asset -->
    <v-btn depressed v-if="alarm.assetId" @click="$router.push({ name: 'assets/id', params: { id: alarm.assetId }})" :title="$t('alarms.show.asset')">
      <icon-asset size="lg"></icon-asset>
    </v-btn>

    <!-- link to issue -->
    <v-btn depressed v-if="issue && alarm.issueId" @click="$router.push({ name: 'issues/id', params: { id: alarm.issueId} })" :title="$t('alarms.show.issue')">
      <icon-issue size="lg"></icon-issue>
    </v-btn>

    <!-- create issue -->
    <v-btn depressed v-if="issue && alarm.assetId && !alarm.issueId" @click="$emit('create-issue', alarm)" :title="$t('issues.new')">
      <font-awesome-icon icon="notes-medical" size="lg"></font-awesome-icon>
    </v-btn>

    <!-- remove alarm -->
    <v-btn depressed v-if="!alarm.active" :key="alarm.active" :title="$t('shared.delete')" @click="confirmDelete(() => remove())">
      <font-awesome-icon icon="trash" size="lg"></font-awesome-icon>
    </v-btn>
  </div>

</template>

<script>
  import IconAsset from '@/observer/shared/icons/icon-asset'
  import IconIssue from '@/observer/shared/icons/icon-issue'
  import dialog from '@/observer/helpers/dialog-client.es6'

  export default {
    name: 'alarm-controls',
    mixins: [ dialog ],

    props: {
      alarm: { required: true },
      issue: { type: Boolean, default: true },
    },

    components: {
      IconIssue,
      IconAsset
    },

    methods: {
      remove() {
        this.$emit('removed', this.alarm)
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  .v-btn {
    border-radius: 0;
    width: $spacing-default * 3;
    min-width: auto !important;
    background-color: transparent !important;

    ::v-deep {
      svg {
        opacity: 0.9;
      }
    }
  }

</style>
